export const IS_DEVELOPMENT = ["localhost", "127.0.0.1"].includes(
  globalThis.location?.hostname,
);
export const IS_NOT_PRODUCTION = IS_DEVELOPMENT;
export const IS_PRODUCTION = !IS_DEVELOPMENT;

// Prevent menu from closing when it, or any of its children, are clicked when the menu is open
export const DO_NOT_CLOSE_CLASS_NAME = "do-not-close-on-click";
